import { getApiContext, GetInitialPropsType } from "~/api"
import { generateCrumbs } from "~/helpers/generateCrumbs"
import IRPost from "~/views/newsPost/IrPost"

const getInitialProps: GetInitialPropsType = async ({ req, query: { slug } }) => {
  const apiContext = await getApiContext(
    [
      { url: `/ir/element` as "/news/element", code: slug as string, urlName: "/news/element" },
      { url: "/magazine/list", query: { items_per_page: 1, page_number: 1 } },
      { url: `/ir/list` as "/press/list", query: { items_per_page: 5, page_number: 1 } },
      { url: `/press/list`, code: "news", query: { items_per_page: 5, page_number: 1 } },
      { url: "/formwithcontacts/list", code: "investors-and-shareholders" },
    ],
    req ? req.headers.host : location.host,
  )

  const { name } = apiContext["/news/element"].response
  const crumbs = generateCrumbs(req?.url, name)

  return { apiContext, crumbs, slug: "ir-blog" }
}

// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
IRPost.getInitialProps = getInitialProps

export default IRPost
